import { z } from 'zod'
import { baseUrl, postJson } from '@/api/http'

const responseSchema = z.object({ status: z.string() })

/** Stop watching a unit's free dates for the given e-mail. */
export async function unsubscribeUnitWatchman(unitId: number, email: string): Promise<void> {
  await postJson(`${baseUrl}/unit/${unitId}/watchman/unsubscribe`, { email }, responseSchema)
}
